import * as React from "react";
const BreakpointMobile = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 18", fill: "currentColor", width: size || "20", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 5h4a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm0 1v7h4V6H8Zm1 5h2v1H9v-1Z" }));
BreakpointMobile.displayName = "BreakpointMobile";
var BreakpointMobile_default = BreakpointMobile;
export {
  BreakpointMobile_default as default
};
